import type { Produto } from '@wms/shared';

/**
 * Formatação de medidas do produto em pt-BR.
 *
 * Regra que vale para as três: `null` é "não cadastrado" e vira "—";
 * ZERO é um valor legítimo (item digital tem dimensão fictícia de 1 cm e
 * volume que arredonda para zero) e nunca deve ser tratado como ausência.
 */
const fmt = (casas: number): Intl.NumberFormat =>
  new Intl.NumberFormat('pt-BR', { maximumFractionDigits: casas });

const fmtPeso = fmt(3);
const fmtVolume = fmt(4);
const fmtMedida = fmt(2);

export function formatarPeso(kg: number | null | undefined): string {
  if (kg === null || kg === undefined || Number.isNaN(kg)) return '—';
  return `${fmtPeso.format(kg)} kg`;
}

export function formatarVolume(m3: number | null | undefined): string {
  if (m3 === null || m3 === undefined || Number.isNaN(m3)) return '—';
  // Volume positivo que arredonda para zero: dizer "0 m³" esconderia que
  // existe volume. Melhor mostrar o limite.
  if (m3 > 0 && m3 < 0.0001) return '< 0,0001 m³';
  return `${fmtVolume.format(m3)} m³`;
}

export function formatarDimensoes(produto: Produto | null | undefined): string | null {
  if (!produto) return null;
  const { alturaCm, larguraCm, profundidadeCm } = produto;
  if (alturaCm === null || larguraCm === null || profundidadeCm === null) return null;
  return `${fmtMedida.format(alturaCm)} × ${fmtMedida.format(larguraCm)} × ${fmtMedida.format(
    profundidadeCm,
  )} cm`;
}

/** Nome comercial quando existe; senão a descrição do cadastro de produtos. */
export function nomeExibido(produto: Produto | null | undefined, alternativa: string): string {
  return produto?.nome?.trim() || produto?.descricao?.trim() || alternativa;
}

export function classificacao(produto: Produto): string[] {
  return [produto.marca, produto.familia, produto.secao, produto.grupo].filter(
    (parte): parte is string => Boolean(parte && parte.trim()),
  );
}
